import type { SimpleStyleT, StyleInputT } from "tweenly"
import { MAX_INPUT_NUM } from "../../../constants"

const positiveUnitaryInput: StyleInputT = {
    type: "number",
    props: {
        inputProps: {
            min: 0,
            max: MAX_INPUT_NUM,
            step: 1,
        },
    },
}

const colorInput: StyleInputT = {
    type: "string",
    props: "",
}

export const borderTopLeftRadius: SimpleStyleT = {
    property: "borderTopLeftRadius",
    value: 0,
    unit: "px",
    input: {
        ...positiveUnitaryInput,
        label: "top left",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-top-left-radius", value: value + unit }
            : { property: "borderTopLeftRadius", value: value + unit },
}

export const borderTopRightRadius: SimpleStyleT = {
    property: "borderTopRightRadius",
    value: 0,
    unit: "px",
    input: {
        ...positiveUnitaryInput,
        label: "top right",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-top-right-radius", value: value + unit }
            : { property: "borderTopRightRadius", value: value + unit },
}

export const borderBottomLeftRadius: SimpleStyleT = {
    property: "borderBottomLeftRadius",
    value: 0,
    unit: "px",
    input: {
        ...positiveUnitaryInput,
        label: "bottom left",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-bottom-left-radius", value: value + unit }
            : { property: "borderBottomLeftRadius", value: value + unit },
}

export const borderBottomRightRadius: SimpleStyleT = {
    property: "borderBottomRightRadius",
    value: 0,
    unit: "px",
    input: {
        ...positiveUnitaryInput,
        label: "bottom right",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-bottom-right-radius", value: value + unit }
            : { property: "borderBottomRightRadius", value: value + unit },
}

// Border width
export const borderWidth: SimpleStyleT = {
    property: "borderWidth",
    value: 0,
    unit: "px",
    input: {
        ...positiveUnitaryInput,
        label: "border width",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-width", value: value + unit }
            : { property: "borderWidth", value: value + unit },
}

// Border style
export const borderStyle: SimpleStyleT = {
    property: "borderStyle",
    value: "solid",
    unit: undefined,
    input: {
        type: "select",
        props: ["none", "solid", "dashed", "dotted", "double"],
        label: "border style",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "border-style", value: String(value) }
            : { property: "borderStyle", value: String(value) },
}

// Border color
export const borderColor: SimpleStyleT = {
    property: "borderColor",
    value: { r: 0, g: 0, b: 0, a: 1 },
    unit: undefined,
    input: {
        ...colorInput,
        label: "border color",
    },
    render: (value, unit, type) => {
        const colorStr = `rgba(${value.r}, ${value.g}, ${value.b}, ${value.a})`
        return type === "css"
            ? { property: "border-color", value: colorStr }
            : { property: "borderColor", value: colorStr }
    },
}

// Box sizing (for border align: inside = border-box, outside = content-box)
export const boxSizing: SimpleStyleT = {
    property: "boxSizing",
    value: "content-box",
    unit: undefined,
    input: {
        type: "select",
        props: ["content-box", "border-box"],
        label: "box sizing",
    },
    render: (value, unit, type) =>
        type === "css"
            ? { property: "box-sizing", value: String(value) }
            : { property: "boxSizing", value: String(value) },
}
